/*
These components were originally abstracted out when they were
going to be used in CAN Recommend (in addition to CAN Compare).
That is no longer the case, but there's no harm in keeping
them separate for future use, so...
*/

import SwitchComponent from './SwitchComponent';
import MoreInfoButton from './MoreInfoButton';
import StyledAccordion from './Accordion';
import StyledRegionName from './StyledRegionName/StyledRegionName';

export { SwitchComponent, MoreInfoButton, StyledAccordion, StyledRegionName };
